import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connectRealtime, onPolicyEvent } from "../../Service/realtime";
import { queuePolicyToast, setToastNavigator } from "./policyToasts";
import { useQrQueue } from "./qrQueue";
import PaymentQrDialog from "./PaymentQrDialog";

/**
 * Live policy updates (2026-10-22): mounted once in the navbar, i.e. on every signed-in page.
 *
 * Opens the socket after the page has drawn (so it never competes with the first load), turns the creator's
 * "notify" messages into toasts and the payment-QR dialog, and leaves "changed" messages to whichever page is open
 * (the Online Policy list and View page refresh themselves). The connection itself lives in Service/realtime.js and
 * survives page changes; sign-out closes it.
 */
const RealtimeBridge = () => {
  const navigate = useNavigate();
  const pushQr = useQrQueue((s) => s.push);

  useEffect(() => {
    setToastNavigator(navigate);
  }, [navigate]);

  useEffect(() => {
    const later = window.requestIdleCallback || ((fn) => setTimeout(fn, 1200));
    const cancel = window.cancelIdleCallback || clearTimeout;
    const handle = later(() => {
      connectRealtime();
    });
    return () => cancel(handle);
  }, []);

  useEffect(
    () =>
      onPolicyEvent((e) => {
        if (e.type !== "notify") return;
        if (e.kind === "qr") pushQr({ policyId: e.policyId });
        else queuePolicyToast(e);
      }),
    [pushQr]
  );

  return <PaymentQrDialog />;
};

export default RealtimeBridge;
